/* eslint-disable import/no-anonymous-default-export */
import actions from "./action";

const initState = {
  loading: false,
  allergiesList: [],
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.GET_ALLERGIES: {
      return {
        ...state,
        allergiesList: [],
        loading: true,
      };
    }
    case actions.GET_ALLERGIES_SUCCESS: {
      return {
        ...state,
        allergiesList: action.payload,
        loading: false,
      };
    }
    case actions.GET_ALLERGIES_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }

    default:
      return state;
  }
};
